import { InMemoryCache } from '@apollo/client';
import { relayStylePagination } from '@apollo/client/utilities';
export var apolloCacheConfig = /*#__PURE__*/new InMemoryCache({
  typePolicies: {
    TalentNboxModuleProcessesResult: {
      keyFields: false
    },
    OrganizationNode: {
      merge: true,
      fields: {
        users: /*#__PURE__*/relayStylePagination(),
        notStudyingUsers: /*#__PURE__*/relayStylePagination(),
        teamsConnection: /*#__PURE__*/relayStylePagination()
      }
    },
    UserOrganizationNode: {
      merge: true,
      fields: {
        users: /*#__PURE__*/relayStylePagination()
      }
    },
    GoalNodeConnection: {
      merge: true,
      fields: {
        goals: /*#__PURE__*/relayStylePagination(['query'])
      }
    },
    TalentQuery: {
      merge: true
    },
    TalentFeedbackQueries: {
      merge: true
    },
    TalentCompetencesQueries: {
      merge: true
    },
    TalentDashboardQuery: {
      merge: true
    },
    TalentRecognitionQueries: {
      merge: true
    },
    TalentRecognitionAdministratorQueries: {
      merge: true
    },
    DashboardLeaderQuery: {
      merge: true
    },
    HRISQueries: {
      merge: true
    },
    OrganizationChartUserReports: {
      merge: true
    },
    TalentDIPQuery: {
      merge: true
    },
    LeaderQuery: {
      merge: true
    },
    CollaboratorQuery: {
      merge: true
    },
    TimeoffQueries: {
      merge: true
    },
    TalentReportsQuery: {
      merge: true
    },
    NboxQueries: {
      merge: true
    },
    WorkFlowQueries: {
      merge: true
    },
    ATSRecruitmentQuery: {
      merge: true
    },
    SecurityQuery: {
      merge: true
    },
    TalentUserSession: {
      merge: true
    },
    UserSession: {
      merge: true
    },
    TalentSession: {
      merge: true
    },
    LearningSession: {
      merge: true
    },
    CentralizedSession: {
      merge: true
    },
    FoundationLeaderQuery: {
      merge: true
    },
    FoundationHomeUserQuery: {
      merge: true
    },
    UserProfileQueries: {
      merge: true
    },
    InternalCommsQueries: {
      merge: true
    },
    InternalCommsChannelsQueries: {
      merge: true
    },
    InternalCommsCommentsQueries: {
      merge: true
    },
    InternalCommsPostsQueries: {
      merge: true
    },
    AuditLogResolvers: {
      merge: true
    },
    CorporateDocumentsQueries: {
      merge: true
    },
    FeaturesFlagQuery: {
      merge: true
    },
    KnowledgeHubQuery: {
      merge: true
    },
    KnowledgeHubConfigQuery: {
      merge: true
    },
    KnowledgeHubV2AdminQuery: {
      merge: true
    },
    ContentEnrollmentMutations: {
      merge: true
    },
    EnrollmentQuery: {
      merge: true
    },
    CourseQuery: {
      merge: true
    },
    QuizMainQueries: {
      merge: true
    },
    BenefitQueryBuilder: {
      merge: true
    },
    SegmentationQueries: {
      merge: true
    },
    ScormQuery: {
      merge: true
    },
    TimeQueries: {
      merge: true
    },
    TimeShiftsQueries: {
      merge: true
    },
    Query: {
      fields: {
        courses: /*#__PURE__*/relayStylePagination(['query']),
        news: /*#__PURE__*/relayStylePagination(['query']),
        skillB2BResultTeamNew: /*#__PURE__*/relayStylePagination(['query']),
        featuredArticles: /*#__PURE__*/relayStylePagination(),
        coursesB2BAdmin: /*#__PURE__*/relayStylePagination(['query']),
        academies: /*#__PURE__*/relayStylePagination(['query']),
        packAcademies: /*#__PURE__*/relayStylePagination(['query']),
        articlesV2: /*#__PURE__*/relayStylePagination(['search', 'categories', 'orderBy']),
        talent_feedback: {
          merge: false
        },
        userTeams: /*#__PURE__*/relayStylePagination(['query'])
      }
    }
  }
});